import { type ReadonlyVec2, vec2 } from 'gl-matrix';

import { vec2extended } from '@canvas/math/vec2';

import {
  type PathSegmentMetadata,
  type PathSegment,
  type PathSegmentLine,
} from '../types';

export function isLineSegment(segment: PathSegment): segment is PathSegmentLine {
  return segment.type === 'line';
}

export function createLine(
  angle: number,
  length: number,
  pathSegmentMetadata?: PathSegmentMetadata
): PathSegmentLine {
  const out: PathSegmentLine = {
    type: 'line',
    angle,
    length,
  };
  if (pathSegmentMetadata) {
    out.pathSegmentMetadata = pathSegmentMetadata;
  }

  return out;
}

export function getLineLength(segment: PathSegmentLine): number {
  return segment.length;
}

export function getPointOnLine(
  cursor: ReadonlyVec2,
  segment: PathSegmentLine,
  proportion: number
): vec2 {
  return vec2.add(
    vec2.create(),
    cursor,
    vec2extended.fromPolar(segment.angle, segment.length * proportion)
  );
}
